import { cn, formatCurrency, timeAgo } from '@/lib/utils';
import { Flex, Text } from '@radix-ui/themes';
import React from 'react';
import { NoncedBid } from './util';
import { InfoTooltip } from '@/app/components/form/FormInfo';
import { BidType } from '@prisma/client';
import { Strikethrough } from './BidHistoryRow';

interface Props {
  bid: NoncedBid;
}

const PersonalBidHistoryRow = ({ bid }: Props) => {
  const {
    createdAt,
    type,
    amount,
    currentHighest = false,
    removed = false,
  } = bid;

  const time = new Date(createdAt);

  let status;
  if (type === BidType.MAX) {
    status = "Max Bid";
  } else if (currentHighest) {
    status = "Winning";
  } else if (removed) {
    status = "Removed";
  } else {
    status = "Outbid";
  }

  return (
    <Flex
      className={cn(
        "w-full shrink-0 py-1.5 rounded-md h-[36px] text-[9pt] sm:text-[12pt]",
        currentHighest && "font-semibold",
        removed && "relative",
      )}
      align="center"
      gap="4"
    >
      {removed && <Strikethrough />}
      <Flex className={cn(
        "text-zinc-500 min-w-[100px] max-w-[100px] sm:min-w-[120px] sm:max-w-[120px]"
      )}>
        <Text className="text-[9pt] sm:text-[12pt]">
          {timeAgo(time)}
        </Text>
      </Flex>

      <Flex justify="between" className="w-full">

        <Flex className={cn(
          "text-zinc-700 text-[9pt] sm:text-[12pt]",
        )}>
          {formatCurrency(amount)}
        </Flex>

        <Flex justify="end" align="center" className={cn(
          "text-zinc-700 text-[9pt] sm:text-[12pt]",
          currentHighest && "text-green-700",
        )}>
          {status}
          {status === "Max Bid" &&
            <InfoTooltip className="w-48 text-sm">You have authorized Biddify to bid on this lot on your behalf up to a maximum of {formatCurrency(amount)}.<br /><br />Our system will automatically place the minimum bid required to ensure you remain the highest bidder.</InfoTooltip>
          }
        </Flex>

      </Flex>
    </Flex>
  );
}

export default PersonalBidHistoryRow;
